/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GuidFilterItemOutput
 */
export interface GuidFilterItemOutput {
    /**
     * 
     * @type {string}
     * @memberof GuidFilterItemOutput
     */
    displayText?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GuidFilterItemOutput
     */
    value?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GuidFilterItemOutput
     */
    isEffective?: boolean;
}

export function GuidFilterItemOutputFromJSON(json: any): GuidFilterItemOutput {
    return GuidFilterItemOutputFromJSONTyped(json, false);
}

export function GuidFilterItemOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): GuidFilterItemOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'displayText': !exists(json, 'displayText') ? undefined : json['displayText'],
        'value': !exists(json, 'value') ? undefined : json['value'],
        'isEffective': !exists(json, 'isEffective') ? undefined : json['isEffective'],
    };
}

export function GuidFilterItemOutputToJSON(value?: GuidFilterItemOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'displayText': value.displayText,
        'value': value.value,
        'isEffective': value.isEffective,
    };
}


